
// TODo : merge this with <progress/>
import CheckIcon from '@mui/icons-material/Check';
import { Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import useRole from '../../../hooks/useRole';
import useStep from '../../../hooks/useStep';
import { NotselectedButtonLink, SelectedButtonLink } from '../../../Styles/componentStyles';

const DrawSideBar = () => {
    const {pathname} = useLocation();
    const role = useRole();
    const currentPath = pathname.split('/').pop();
    console.log('currentPath',currentPath);
    const step=useStep();
    const { i18n } = useTranslation();
    const navigate = useNavigate();

    const rectifNumberIon=(curr)=>{
        if(curr==4)
            return '3';
        else if (curr==0)
            return '1';
        else
            return curr;
    };

    const dsiplayEtatIcon=(curr)=>{
        let lastNumberInCurrentPath;
        if(currentPath=='completeProfile')
            lastNumberInCurrentPath=0;
        else
            lastNumberInCurrentPath=currentPath.charAt(currentPath.length-1);

        if(step == curr ||(step==3 && curr==2))
            return (

                <div className='frame5Client'>
                    <div className='frame6Client'>
                        {rectifNumberIon(curr)}
                    </div>
                </div>
            );
        else if(Number(lastNumberInCurrentPath)> curr || step > curr)
            return (
                <div className='frame17Client'>
                    <div className='frame18Client'>
                        <CheckIcon style={{color:'white'}} />
                    </div>
                </div>
            );
        else
            return (
                <div className='frame12Client'>
                    <div className='frame15Client'>
                        {rectifNumberIon(curr)}
                    </div>
                </div>
            );
    };

    return (
        <div className='GrandBoxStep2Client'>
            <div style={{display:'flex',flexDirection:'column',gap:'16px'}}>
                <div className='StepsSecondPart'>
                    <div className='frame4Client'>
                        <div className='frame9Client'>
                            <Button
                                variant='text'
                                onClick={()=>{navigate(`/${role}/completeProfile`);}}
                                disabled={(!(currentPath == 'completeProfile' ) && Number(step)>=0) ? false : true}
                                style={(!(currentPath == 'completeProfile' ) && Number(step)==0) ? SelectedButtonLink:NotselectedButtonLink }
                                startIcon={dsiplayEtatIcon(0)}
                            >
                                {i18n.t('Etape 1')}
                            </Button>
                        </div>
                    </div>
                </div>
                <div className='Rect1'>
                    <div className='LineRect1'>
                    </div>
                </div>
                <div className='frame11Client'>
                    <div className='frame9Client'>
                        <Button
                            variant='text'
                            onClick={()=>{navigate(`/${role}/completeProfile/step2`);}}
                            disabled={(!(currentPath == 'step2' || currentPath == 'step3') && (Number(step)>=2)) ? false : true}
                            style={(!(currentPath == 'step2' || currentPath == 'step3') && (Number(step)==2)) ?SelectedButtonLink: NotselectedButtonLink}
                            startIcon={dsiplayEtatIcon(2)}
                        >
                            {i18n.t('Etape 2')}
                        </Button>
                    </div>
                </div>
                <div className='Rect2'>
                    <div className='LineRect1'>
                    </div>
                </div>
                <div className='frame16Client'>
                    <div className='frame9Client'>
                        <Button
                            variant='text'
                            onClick={()=>{navigate(`/${role}/completeProfile/step4`);}}
                            disabled={(!(currentPath == 'step4' ) && Number(step)>=4) ? false : true}
                            style={(!(currentPath == 'step4' ) && Number(step)==4) ? SelectedButtonLink :NotselectedButtonLink}
                            startIcon={dsiplayEtatIcon(4)}
                        >
                            {i18n.t('Etape 3')}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DrawSideBar;
